export const getIEVersion = () => {
  if (typeof window === 'undefined') {
    return -1
  }
  if (!window?.navigator || !window?.navigator?.userAgent) {
    return -1
  }
  const { userAgent } = navigator //取得浏览器的userAgent字符串
  const isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 //判断是否IE<11浏览器
  const isEdge = userAgent.indexOf('Edge') > -1 && !isIE //判断是否IE的Edge浏览器
  const isIE11 =
    userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    const fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion == 7) {
      return 7
    } else if (fIEVersion == 8) {
      return 8
    } else if (fIEVersion == 9) {
      return 9
    } else if (fIEVersion == 10) {
      return 10
    } else {
      return 6 //IE版本<=7
    }
  } else if (isEdge) {
    return 'edge' //edge
  } else if (isIE11) {
    return 11 //IE11
  } else {
    return -1 //不是ie浏览器
  }
}

// 是否需要全局升级提示
export const isHasTips = () => {
  const ieVersion = getIEVersion()
  // ie 11以下
  if (ieVersion > 0 && ieVersion <= 11) {
    return true
  }

  return false
}

// 是否为 Firefox
export const isFirefox = () => {
  if (typeof window === 'undefined') {
    return false
  }
  if (!window?.navigator || !window?.navigator?.userAgent) {
    return false
  }

  if (window?.navigator?.userAgent?.indexOf('Firefox') >= 0) {
    return true
  }

  return false
}
